
// 测试
// let baseUrl = 'http://test.yuenlongbarrage.hk/'

// 正式
let baseUrl = 'https://admin.yuenlongbarrage.hk/'


export default baseUrl;
